import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// * Main Wrapper for the hero banner
export const OptimumHeroVariationsWrapperStyles = css`
  &.pc-optimum-hero {
    padding: 20px 15px;
    min-height: 490px;
    text-align: left;
    background: ${themeGet('colors.pc-red', '#E1251B')};
    align-content: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.pc-optimum-hero {
      min-height: 350px;
      padding: 30px 30px;

      /* &:after {
        height: 20%;
      } */
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.pc-optimum-hero {
      padding: 47px 57px;

      /* &:after {
        height: 15%;
      } */
    }
  }
`;

// * Styling for the Div that wraps all the text copy
export const OptimumHeroVariationsContentStyles = css`
  ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
    position: relative;
    z-index: 1;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      max-width: 55%;
    }
  }
`;

// * Styling for the heading inside the content box
export const OptimumHeroVariationsTitleStyles = css`
  ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
    color: ${themeGet('colors.white')};
    font-size: 36px;
    font-weight: ${themeGet('fontWeights.medium')};
    letter-spacing: 0;
    line-height: 1.09;

    &:lang(fr) {
      font-size: 36px;
      line-height: 1.2;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      font-size: 44px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 1.09;
    }
  }

  @media only screen and (min-width: 480px) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      font-size: 54px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: -0.26px;
      line-height: 1.2;

      &:lang(fr) {
        font-size: 36px;
        line-height: 1.4;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      font-size: 60px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 1.2;

      &:lang(fr) {
        font-size: 40px;
        line-height: 1.3;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      font-size: 72px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 1.2;

      &:lang(fr) {
        font-size: 48px;
        line-height: 1.2;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      font-size: 92px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 1.2;

      &:lang(fr) {
        font-size: 56px;
      }
    }
  }
`;

// * Intro body copy below the heading in the hero
export const OptimumHeroVariationsIntroStyles = css`
  ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
    margin: 15px 0 0;
    width: 100%;

    p {
      color: ${themeGet('colors.white')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      margin: 30px 0 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      margin: 46px 0 0;
    }
  }
`;

// * The Div that wraps the CTA in the Hero
export const OptimumHeroVariationsCTAWrapperStyles = css`
  ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
    padding-top: 14rem;
    align-items: center;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      padding-top: 70vw;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding-top: 80px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    }
  }
`;

export const OptimumHeroVariationsMediaContainerStyles = css`
  ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
    margin: 0;
    z-index: 1;
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 90px;
    width: calc(100% - 40px);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      width: 45%;
      transform: none;
      top: auto;
      right: 0;
      bottom: 0;
      left: auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      width: 45%;
      position: absolute;
      top: auto;
      right: 0;
      bottom: -3rem;
      left: auto;
      transform: none;
      display: none;
    }
  }
`;

export const OptimumHeroVariationsHeroImageStyles = css`
  ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
    margin: 0;
    height: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${OptimumHeroVariationsWrapperStyles}.pc-optimum-hero & {
      margin: 0;
      height: 270px;
      height: 100%;
      width: 100%;
    }
  }
`;
